import {
  DispDepositType,
  DomesticResidenceFlg,
} from "../../assets/data/Constants";
import { labelids } from "../../assets/data/TkExplanationProperty";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import { TkGetCodeList } from "../../utils/TkGetCode";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const stepper = [
  "退職者確認",
  "請求者の確認",
  "請求者情報の登録",
  "振込先金融機関の登録",
  "本人確認の書類の添付",
  "退職所得の受給に関する申告書の登録",
  "源泉徴収票の確認",
  "申告書兼退職所得申告書の作成",
  "退職所得情報登録",
  "登録内容の確認",
  "機構へ提出",
];

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    keyword: "info",
    type: "explanatoryText",
    explanatoryText: labelids.labelid.LBLR411107_01,
    explanatoryTextRule: "\\n",
  },
  {
    title: "退職者名",
    keyword: "retireeName",
    type: "contractorAndNumber",
    contractorName: "退職者名",
    showLine: false,
  },
  {
    title: "振込先金融機関",
    keyword: "bankSelect",
    type: "bankSearch",
    requiredIcon: true,
    helpicon: true,
    isDaikou: false,
    helpText:
      "退職手当金の振込金融機関を「振込先金融機関登録」ボタンを押して選択してください。",
  },
  {
    title: "国内居住",
    keyword: "domesticResidenceFlg",
    type: "radio",
    radioPropsList: TkGetCodeList(DomesticResidenceFlg),
    requiredIcon: true,
    showLine: false,
  },
  {
    title: "金融機関コード",
    keyword: "bankCd",
    type: "text",
    requiredIcon: true,
    helpicon: true,
    helpText: "退職手当金振込先金融機関のコードです。",
  },
  {
    title: "金融機関名",
    keyword: "bankName",
    type: "text",
    requiredIcon: true,
    helpicon: true,
    helpText: "退職手当金振込先金融名です。",
  },
  {
    title: "支店コード",
    keyword: "branchCd",
    type: "text",
    requiredIcon: true,
    helpicon: true,
    helpText: "退職手当金振込先金融機関の支店コードです。",
  },
  {
    title: "支店名",
    keyword: "branchName",
    type: "text",
    requiredIcon: true,
    helpicon: true,
    helpText: "退職手当金振込先金融機関の支店名です。",
  },
  {
    title: "預金種目",
    keyword: "depositType",
    type: "radio",
    radioPropsList: TkGetCodeList(DispDepositType),
    setDefaultValue: DispDepositType["普通"],
    requiredIcon: true,
    helpicon: true,
    helpText: "退職手当金振込先口座の預金種目です。",
    disabled: true,
  },
  {
    title: "口座番号",
    keyword: "accountNo",
    requiredIcon: true,
    inputProps: { maxLength: 7 },
    helpicon: true,
    helpText:
      "退職手当金振込先金融機関の口座番号です。7桁の番号をご入力ください。6桁の場合は、口座番号の前「0」をつけて入力してください。",
  },
  {
    title: "口座名義人（半角ｶﾀｶﾅ）",
    keyword: "accountNameKana",
    type: "name",
    requiredIcon: true,
    useFurigana: true,
    hafWidth: true,
    convertToHalfwidth: true,
    convertBankFormat: true,
    helpicon: true,
    helpText:
      "退職手当金振込先金融機関の口座名義（フリガナ）を入力してください。",
  },
];

const schema = {
  bankSelect: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  depositType: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  accountNo: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    minLength: {
      value: 7,
      message: TkPropertyMessageGet("TKMSG_SCR0077E", "7"),
    },
    maxLength: {
      value: 7,
      message: TkPropertyMessageGet("TKMSG_SCR0077E", "7"),
    },
  },
  accountNameKana: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^([ｱ-ﾝｦ0-9\\(\\)\\.\\-\\/ ]|([-])|([ｳｶ-ﾄﾊ-ﾎ]ﾞ)|([ﾊ-ﾎ]ﾟ))+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0054E"),
    },
    maxLength: {
      value: 48,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "47"),
    },
  },
};

const isCheckedSchema = {
  domesticResidenceFlg: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
};

export { stepper, fakeTableList, schema, isCheckedSchema };
